import { useState } from 'react'
import styled from 'styled-components'
import { RiLockLine } from 'react-icons/ri'
import PinInput from './PinInput'
import useTranslation from '../../hooks/useTranslation'
import { Background, Card, Title, Subtitle, IconWrapper, Button, ErrorMsg } from './styles'


const PinGroup = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
`

const EMPTY_PIN = ['', '', '', '']

const PortalPasscodeScreen = ({ onSubmit }) => {
    const [pin, setPin] = useState(EMPTY_PIN)
    const [error, setError] = useState(null)
    const [lockedUntil, setLockedUntil] = useState(null)
    const [submitting, setSubmitting] = useState(false)
    const { t } = useTranslation()

    const passcode = pin.join('')
    const complete = passcode.length === 4

    const isLocked = lockedUntil && new Date(lockedUntil) > new Date()

    const formatLockTime = (isoString) => {
        const remaining = Math.ceil((new Date(isoString) - Date.now()) / 60000)
        return remaining > 1 ? `${remaining} minutes` : '1 minute'
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        if (!complete || isLocked) return
        setSubmitting(true)
        setError(null)
        const err = await onSubmit(passcode)
        if (err) {
            if (err.name === 'error.passcode.locked') {
                setLockedUntil(err.lockedUntil)
            } else {
                setError(t('portal.passcode.invalid'))
            }
            setPin(EMPTY_PIN)
        }
        setSubmitting(false)
    }

    return (
        <Background>
            <Card>
                <IconWrapper><RiLockLine /></IconWrapper>
                <Title>{t('portal.passcode.title')}</Title>
                <Subtitle>{t('portal.passcode.subtitle')}</Subtitle>
                <form onSubmit={handleSubmit} style={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '1.25rem', alignItems: 'center' }}>
                    <PinGroup>
                        <PinInput
                            values={pin}
                            onChange={setPin}
                            type="password"
                            autoFocus
                        />
                        {error && <ErrorMsg>{error}</ErrorMsg>}
                        {isLocked && (
                            <ErrorMsg>
                                {t('portal.passcode.locked').replace('{minutes}', formatLockTime(lockedUntil))}
                            </ErrorMsg>
                        )}
                    </PinGroup>
                    <Button type="submit" disabled={!complete || submitting || isLocked}>
                        {t('portal.passcode.submit')}
                    </Button>
                </form>
                <Subtitle>{t('portal.passcode.forgot')}</Subtitle>
            </Card>
        </Background>
    )
}

export default PortalPasscodeScreen
